const SEARCH_ENGINE_HOSTNAME_SUFFIXES = [
  'google.com',
  'google.co.uk',
  'google.ca',
  'google.com.au',
  'bing.com',
  'duckduckgo.com',
  'yahoo.com',
  'search.yahoo.com',
  'search.brave.com',
  'ecosia.org',
  'startpage.com',
  'kagi.com',
  'baidu.com',
  'yandex.com',
  'yandex.ru',
]

function isSearchEngineHostname(hostname: string): boolean {
  const host = hostname.toLowerCase()
  return SEARCH_ENGINE_HOSTNAME_SUFFIXES.some(
    (suffix) => host === suffix || host.endsWith(`.${suffix}`)
  )
}

/**
 * Window-time read of the `?ref=` entry param for feeding
 * `classifyEntryReferrer`, mirroring the pages router's
 * `typeof router.query.ref === 'string'` check (a repeated param produced an
 * array there and classified as null). Call from effects/handlers only —
 * never during render — so App Router static generation is unaffected
 * (`useSearchParams()` in render would force a CSR bailout).
 */
export function readEntryRefParam(): string | null {
  if (typeof window === 'undefined') return null
  const values = new URLSearchParams(window.location.search).getAll('ref')
  if (values.length !== 1) return null
  return values[0] ?? null
}

export function classifyEntryReferrer(refParam: string | null): string {
  if (refParam) return refParam
  if (typeof document === 'undefined') return 'direct'
  const ref = document.referrer
  if (!ref) return 'direct'
  try {
    const refUrl = new URL(ref)
    if (refUrl.hostname === window.location.hostname) {
      if (refUrl.pathname === '/' || refUrl.pathname === '') return 'homepage'
      if (refUrl.pathname.startsWith('/reports')) return 'reports-index'
      // `/gift-guide` was renamed to `/obsessions` (301-redirected). Match
      // both so legacy in-app referrers still bucket correctly; the analytics
      // value is intentionally left as `gift-guide-index` to preserve
      // historical continuity in dashboards.
      if (
        refUrl.pathname.startsWith('/obsessions') ||
        refUrl.pathname.startsWith('/gift-guide')
      )
        return 'gift-guide-index'
      return 'internal'
    }
    if (isSearchEngineHostname(refUrl.hostname)) return 'search'
    return 'external'
  } catch {
    return 'external'
  }
}
